export const DAY_AND_MONTH_FORMAT = 'MMMM dd';
export const DAY_MONTH_AND_YEAR_FORMAT = 'MMMM dd, yyyy';
export const MONTH_DAY_YEAR_FORMAT = 'MM/dd/yyyy';
export const DATE_MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

type locale = 'en-US' | 'en-GB' | 'en-CA';

export const dateFormatOptions: Array<{
    value: locale;
    name: string;
}> = [
        { value: 'en-US', name: 'MM/dd/yyyy' },
        { value: 'en-GB', name: `dd/MM/yyyy` },
        { value: 'en-CA', name: 'yyyy/MM/dd' },
    ];

interface RegionMap {
    short: string;
    long: string;
    longWithYear: string;
    axis: string;
    moment: {
        short: string;
        long: string;
        longWithYear: string;
        axis: string;
    };
}

type DateFormatRegionMap = {
    [key: string]: RegionMap;
};

export const dateFormatRegionMap: DateFormatRegionMap = {
    'en-US': {
        short: 'MM/dd/yyyy',
        long: 'MMMM dd',
        longWithYear: 'MMMM dd, yyyy',
        axis: 'MMM dd',
        moment: {
            short: 'MM/DD/YYYY',
            long: 'MMMM DD',
            longWithYear: 'MMMM DD, YYYY',
            axis: 'MMM DD',
        }
    },
    'en-GB': {
        short: 'dd/MM/yyyy',
        long: 'dd MMMM',
        longWithYear: 'MMMM dd, yyyy',
        axis: 'dd MMM',
        moment: {
            short: 'DD/MM/YYYY',
            long: 'DD MMMM',
            longWithYear: 'MMMM DD, YYYY',
            axis: 'DD MMM',
        }
    },
    'en-CA': {
        short: 'yyyy/MM/dd',
        long: 'MMMM dd',
        longWithYear: 'MMMM dd, yyyy',
        axis: 'dd MMM',
        moment: {
            short: 'YYYY/MM/DD',
            long: 'MMMM DD',
            longWithYear: 'MMMM DD, YYYY',
            axis: 'DD MMM',
        }
    },
};
